import React from 'react';
import {
  AppButton,
  Box,
  Inscription,
} from '@common-fe/common-fe';

import { EmployerStatus } from '@/modules/employer/employer.constants';

interface Props {
  title: string;
  description?: string;
  employerStatus?: EmployerStatus;
  onReactivateEmployer: () => void;
}

export const ReactivationDangerZoneCard: React.FC<Props> = ({
  title,
  description,
  employerStatus,
  onReactivateEmployer,
}) => {
  return (
    <Box
      data-testid="EmployerReactivation_DangerZone_container"
      fill
      align="center"
      pad="spacing24"
      round="container1Round"
      direction="column"
      background="canvas"
      margin={{ right: 'spacing8' }}
      style={{ position: 'relative' }}
    >
      <Inscription size="2xl" color="textBody" weight={700}>
        {title}
      </Inscription>
      
      {description ? (
        <Box margin={{ top: 'spacing12' }} direction="row">
          <Inscription color="textBody" textAlign="center" style={{ whiteSpace: 'pre-line' }}>
            {description}
          </Inscription>
        </Box>
      ) : null}

      {employerStatus !== EmployerStatus.PendingReactivation ?
      <Box
        width="100%"
        margin={{ top: 'spacing24' }}
        direction="row"
        gap="spacing12"
      >
        <Box fill>
          <AppButton
            testId="reactivate-employer"
            size="L"
            onClick={onReactivateEmployer}
            width="100%"
          >
            Reactivate
          </AppButton>
        </Box>
      </Box> : null}
    </Box>
  );
};